import {trigger, state, animate, style, transition} from '@angular/core';

export function routerTransition() {
  return fadeOutSlideDown();
}

export function contentTransition() {
  return fadeOutEaseFromLeft();
}

function fadeOutSlideFromLeft() {
  return trigger('routerTransition', [
    state('void', style({position:'absolute', width:'100%', height:'100%'}) ),
    state('*', style({position:'absolute', width:'100%', height:'100%'}) ),
    transition(':enter', [
      style({transform: 'translateX(-20px)', opacity: '0.0'}),
      animate('0.15s ease-in-out', style({transform: 'translateX(0px)', opacity:'1.0'}))
    ]),
    transition(':leave', [
      style({opacity: '1.0'}),
      animate('0.1s ease', style({opacity:'0.0'}))
    ])
  ]);
}

export function fadeOutEaseFromLeft() {
  return trigger('routerTransition', [
    state('void', style({ position:'absolute', width:'100%' }) ),
    state('*', style({ position:'relative', width:'100%' }) ),
    transition(':enter', [
      style({transform: 'translateX(-10px)', opacity: '0.0'}),
      animate('0.15s ease-in-out', style({transform: 'translateX(0px)', opacity:'1.0'}))
    ]),
    transition(':leave', [
      style({opacity: '1.0', transform: 'translateX(0px)'}),
      animate('0.1s ease', style({opacity:'0.0', transform: 'translateX(10px)'}))
    ])
  ]);
}

export function fadeOutSlideDown() {
  return trigger('routerTransition', [
    state('void', style({position:'absolute', width:'100%', height:'100%'}) ),
    state('*', style({position:'absolute', width:'100%', height:'100%'}) ),
    transition(':enter', [
      style({transform: 'translateY(-10px)', opacity: '0.0'}),
      animate('0.15s ease-in-out', style({transform: 'translateY(0px)', opacity:'1.0'}))
    ]),
    transition(':leave', [
      style({transform: 'translateY(0px)', opacity:'1.0'}),
      animate('0.1s ease', style({transform: 'translateY(-10px)', opacity:'0.0'}))
    ])
  ]);
}

function fadeOutIn() {
  return trigger('routerTransition', [
    state('void', style({position:'absolute', width:'100%', height:'100%'}) ),
    state('*', style({position:'absolute', width:'100%', height:'100%'}) ),
    transition(':enter', [
      style({opacity: '0.0'}),
      animate('0.1s ease-in-out', style({opacity:'1.0'}))
    ]),
    transition(':leave', [
      style({opacity:'1.0'}),
      animate('0.1s ease-in-out', style({opacity:'0.0'}))
    ])
  ]);
}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/animations.ts